var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 1.66666C2.78596 1.66666 1.66667 2.78595 1.66667 4.16666V4.58333V5.41666V15.8333C1.66667 17.2141 2.78596 18.3333 4.16667 18.3333H15.8333C17.2141 18.3333 18.3333 17.2141 18.3333 15.8333V15V13.3333V11.25V10V8.33333V7.5C18.3333 6.11929 17.2141 5 15.8333 5H10.8333H10H9.16667H4.16667C3.70643 5 3.33333 4.6269 3.33333 4.16666C3.33333 3.70643 3.70643 3.33333 4.16667 3.33333H14.1667H15V1.66666H14.1667H4.16667ZM3.33333 6.52441V15.8333C3.33333 16.2936 3.70642 16.6667 4.16667 16.6667H15.8333C16.2936 16.6667 16.6667 16.2936 16.6667 15.8333V15H15C13.1589 15 11.6667 13.5077 11.6667 11.6667C11.6667 9.82559 13.1589 8.33333 15 8.33333H16.6667V7.5C16.6667 7.03975 16.2936 6.66666 15.8333 6.66666H10.8333H10H9.16667H4.16667C3.87447 6.66666 3.59398 6.61654 3.33333 6.52441ZM16.6667 11.25V13.3333H15C14.0794 13.3333 13.3333 12.5873 13.3333 11.6667C13.3333 10.7461 14.0794 10 15 10H16.6667V11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutline);
export default __webpack_public_path__ + "static/media/wallet-outline.09fe34b7ffe1fd5273a6711ce72e3ac9.svg";
export { ForwardRef as ReactComponent };